// Note that these are aligned with apps, don't change the values without
// checking with Team Analytics
export enum SOURCE_SCREEN {
    BRAND = 'Brand',
    CAMPAIGN = 'Campaign',
    CATEGORY = 'Category',
    CAUSE = 'Cause',
    CAUSES = 'Causes',
    ENDLESS_RECOMMENDATION = 'Endless recommendation',
    FAVOURITE_SELLERS = 'Favourite sellers',
    SAVED_SEARCHES = 'Saved searches',
    HOME = 'Home',
    MY_TRADERA_OVERVIEW = 'My Tradera overview',
    NEAR_YOU = 'Local buying',
    SEARCH_RESULTS = 'Search results',
    SELLER_PROFILE = 'Seller profile',
    STORE_PROFILE = 'Store profile',
    TOP_LISTS = 'Top lists',
    VALUATION = 'Valuation',
    VIP = 'View item',
    WISHLIST = 'Wishlist',
}
